export default "__VITE_ASSET__CMjtUq6G__"